/**操作记录模块 */
import request from '../request/http';
/**新增操作记录 */
export function AddOptRecord(data){
    return request({
        url: '/sp/optRecord/addOptRecord',
        method: 'post',
        data
    })
}